import { Button, Card, Form } from 'antd'

import React, { useEffect, useState } from 'react'
import { Line } from '@ant-design/plots'
import getIntegrationDashboardStat, {
	GetIntegrationDashboardStatParams,
} from 'api/dashboard/getIntegrationDashboardStat'

import moment from 'moment'
import convertToFilterDate from 'utils/convertToFilterDate'

import DatePicker, { DatePickerValue } from 'component/UI/DatePicker'
import style from './style.module.scss'

interface PropType {
	clientId?: string
}
interface LineChartType {
	DATE?: string
	HOUR?: string
	'INTEGRATION COUNT': number
}

interface FormValues {
	date: DatePickerValue
}

const IntegrationStatsCard: React.FC<PropType> = ({ clientId }) => {
	const [data, setData] = useState<LineChartType[]>([])

	const [loading, setLoading] = useState<boolean>(true)

	const [xField, setXField] = useState<'HOUR' | 'DATE'>('DATE')

	// const [filterApplied, setFilterApplied] = useState<boolean>(false)

	const [form] = Form.useForm<FormValues>()

	const [option, setOption] = useState<GetIntegrationDashboardStatParams>({
		dateFilter: 'weekly',
		client: clientId,
	})

	const handleFieldsChange = () => {
		const filter = convertToFilterDate({
			type: form.getFieldsValue().date.type,
			value: form.getFieldsValue().date.value,
		})

		if (filter.dateType === 'day') {
			setOption({
				dateFilter: filter.endDate ? undefined : `daily`,
				startDate: filter.endDate,
				client: clientId,
			})
			return
		}

		setOption({
			client: clientId,
			dateFilter:
				filter.startDate || filter.endDate || filter.dateType === 'range'
					? undefined
					: `${filter.dateType}ly`,
			startDate: filter.startDate,
			endDate: filter.endDate,
		})
	}
	const handleClearFilter = () => {
		form.setFieldsValue({
			date: null as any,
		})
		setOption({ client: clientId })
	}

	useEffect(() => {
		const fetchIntegrationStats = async () => {
			setLoading(true)
			try {
				const response = await getIntegrationDashboardStat(option)

				if (response.records) {
					setXField('DATE')
					setData(
						response.records
							.sort((left, right) =>
								moment.utc(left.date).diff(moment.utc(right.date))
							)
							.map(ele => ({
								DATE: String(moment(ele.date).format('DD-MM-YYYY')),
								'INTEGRATION COUNT': ele.count,
							}))
					)
				} else if (response.response) {
					setXField('HOUR')
					setData(
						response.response
							.sort((a, b) => {
								return a.hour - b.hour
							})
							.map(ele => ({
								HOUR: `${ele.hour}:00`,
								'INTEGRATION COUNT': ele.count,
							}))
					)
				}
				setLoading(false)
			} catch {
				setLoading(false)
			}
		}
		fetchIntegrationStats()
	}, [clientId, option, form])

	return (
		<Card title='Integration Stats' className={style.layout}>
			<Form
				form={form}
				name='control-hooks'
				className={style.form}
				initialValues={{
					date: {
						type: 'week',
					},
				}}
				onFieldsChange={handleFieldsChange}
			>
				<Form.Item name='date'>
					<DatePicker disableDate format='DD-MM-YYYY' />
				</Form.Item>
				<Form.Item>
					<Button danger htmlType='button' onClick={handleClearFilter}>
						Clear filter
					</Button>
				</Form.Item>
			</Form>
			<div className={style.position}>
				<Line
					loading={loading}
					data={data}
					xField={xField}
					yField='INTEGRATION COUNT'
					xAxis={{ tickCount: 5 }}
					point={{
						size: 5,
						// shape: 'spline',
						style: {
							fill: 'white',
							stroke: '#5B8FF9',
							lineWidth: 2,
						},
					}}
				/>
			</div>
		</Card>
	)
}
IntegrationStatsCard.defaultProps = {
	clientId: undefined,
}
export default IntegrationStatsCard
